<div class="col-12" *ngIf="data" style="padding-top: 32px;">
  <div
      class="card-panel border-secondary"
      style="box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2); height: 285px;"
  >
      <!--h3 class="card-header section-title" style="font-size: 1.6rem">
          {{ data.header }}
      </!--h3-->

      <div class="p-3">
        <!--app-section-title ng-reflect-section-title-config="[object Object]"-->
          <div class="table-title d-flex flex-column flex-md-row align-items-center">
            <div class=""><!--div class="ml-lg-3"-->
              <img height="70px" width="60px" class="magnifying-glass-title__icon"
                    src="assets/images/signedContract.png" alt="papyrus icon for table title">
            </div>
            <div style="padding-top: 10px; padding-left: 10px;">
              <h3 class="d-inline-block align-self-center ml-lg-1 section-title" style="font-size: 1.6rem;">
                Συμβόλαιο
              </h3>
            </div>
          </div>
        <!--app-section-title-->
      </div>

      <div class="card-body p-3">
          <div class="row card-subtitle pl-3 mt-1 align-bottom">
              <h5
                  class="card-subtitle mb-2 text-muted"
                  style="font-size: 1rem"
              >
                  {{ data.id }}
              </h5>
          </div>
          <div class="row card-subtitle pl-3 mt-1 pr-3">
              <h4
                  class="card-subtitle mb-2 text-muted"
                  style="font-size: 1rem"
              >
                  {{ data.date }}
              </h4>
          </div>

          <div class="row card-subtitle pl-1 mt-1 pr-1">
            <button class="mt-3 btn btn-secondary app-button" (click)="documentAction(data.appid,data.docid)">
                <span style="font-size: medium">
                    {{ data.button }}</span
                >
            </button>
            <div *ngIf="data.button2">
              <button class="mt-3 btn btn-secondary app-button" (click)="clickHandler(data.button2Method, data.button2Arg)">
                  <span style="font-size: medium">
                      {{ data.button2 }}</span
                  >
              </button>
            </div>
          </div>
      </div>
  </div>
</div>
